import { ChangeRequestData } from '../../../../../../api/theHive/notices/types';
import { Constants } from '../../../../../../constants/hiveNotices';
import {
  ChangeRequestCard,
  ChangeRequestChip,
  ChangeRequestChips,
  ChangeRequestLabel,
  ChangeRequestRow,
  ChangeRequestTitle,
} from '../styles';
import { getRequestedCriteriaGroups, groupRequestedPolesByUf } from '../utils';

interface ChangeRequestSummaryProps {
  requests: ChangeRequestData[];
}

// What the self-management request adds — requested poles and criteria groups —
// so the analyst sees the scope before the documentation itself.
export function ChangeRequestSummary({
  requests,
}: ChangeRequestSummaryProps): JSX.Element | null {
  const polesByUf = groupRequestedPolesByUf(requests);
  const criteriaGroups = getRequestedCriteriaGroups(requests);

  if (polesByUf.length === 0 && criteriaGroups.length === 0) return null;

  return (
    <ChangeRequestCard>
      <ChangeRequestTitle>
        {Constants.changeRequestSummaryTitle}
      </ChangeRequestTitle>
      {polesByUf.length > 0 && (
        <ChangeRequestRow>
          <ChangeRequestLabel>
            {Constants.changeRequestPoles}
          </ChangeRequestLabel>
          <ChangeRequestChips>
            {polesByUf.map(({ uf, count }) => (
              <ChangeRequestChip key={uf}>
                {`${uf} - ${count} ${
                  count === 1
                    ? Constants.changeRequestPoleSingular
                    : Constants.changeRequestPolePlural
                }`}
              </ChangeRequestChip>
            ))}
          </ChangeRequestChips>
        </ChangeRequestRow>
      )}
      {criteriaGroups.length > 0 && (
        <ChangeRequestRow>
          <ChangeRequestLabel>
            {Constants.changeRequestTypologyGroups}
          </ChangeRequestLabel>
          <ChangeRequestChips>
            {criteriaGroups.map((group) => (
              <ChangeRequestChip key={group.id}>{group.name}</ChangeRequestChip>
            ))}
          </ChangeRequestChips>
        </ChangeRequestRow>
      )}
    </ChangeRequestCard>
  );
}
